import { Component, OnInit, Input, Output  } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'app-primary-button',
  templateUrl: './primary-button.component.html',
  styleUrls: ['../button.component.scss'],
})
export class PrimaryButtonComponent implements OnInit {
  @Input() normalBtn:boolean = false;
  @Input() btnText: string;
  @Input() customClassAppBtn: string; //recibe: class
  @Input() isDisabled:boolean = false;
  @Input() type: string = 'button'; //submit | button | reset

  @Input() addIcon: string | null = null; //left | right
  @Input() iconClass: string = '';

  @Output() btnClick: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {}

  onClickBtn(event:Event) {
    this.btnClick.emit(event);
  }

}

